import { useState } from 'react';
import BaseLocationMapping from '../common/BaseLocationMapping';
import { postData } from '../../../../../api/componentAPIs';
import DOWEditForm from './EditForm';
import DisplayCard from './DOWDisplayCard';
import { sanitizeInput } from '../../../../../utilities/dataUtils';
import CustomConfirmationDialog from '../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';
import DaySelectionFilter from './DaySelectionFilter';

const DOWMapping = (props) => {
  const [isLocationConfirmationDialogOpen, setIsLocationConfirmationDialogOpen] = useState(false);
  const [selectedLocationToDelete, setSelectedLocationToDelete] = useState(null);

  const populateSubmitDetails = (formData) => {
    const {
      terminalId,
      isNewLocationMapping,
      boundary,
      locationMappingId,
      locationName,
      dowDelWindow,
    } = formData;
    return {
      terminalId,
      boundary: JSON.stringify(boundary),
      deliveryLocationMappingId: isNewLocationMapping ? null : locationMappingId,
      deliveryLocationMappingName: sanitizeInput(locationName),
      deliveryDOWOpen: dowDelWindow.filter((day) => day.value).map((day) => day.name.toLowerCase())
    };
  };

  const saveLocationMapping = (data) => {
    return postData('SaveDeliveryLocationMapping', populateSubmitDetails(data));
  };

  const onConfirmDelete = () => {
    props.onDeleteLocation({ ...selectedLocationToDelete });
    setIsLocationConfirmationDialogOpen(false);
    setSelectedLocationToDelete(null);
  };

  const onCancelDelete = () => {
    setIsLocationConfirmationDialogOpen(false);
    setSelectedLocationToDelete(null);
  };

  const onDeleteLocation = (card) => {
    setSelectedLocationToDelete(card);
    setIsLocationConfirmationDialogOpen(true);
  };

  return (
    <>
      <DaySelectionFilter handleFilterChange={props.handleDowFilterChange} />
      <BaseLocationMapping
        {...props}
        locationMappingData={props.filteredDowDeliveryData}
        onDeleteLocation={onDeleteLocation}
        saveLocationMapping={saveLocationMapping}
        locationLabel="DOW Location"
        EditForm={DOWEditForm}
        DisplayCard={DisplayCard}
      />
      {isLocationConfirmationDialogOpen && (
        <CustomConfirmationDialog
          title="Delete Selected Region"
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Delete"
          mode="danger"
          onConfirm={onConfirmDelete}
          onCancel={onCancelDelete}>
          Are you sure you want to delete {selectedLocationToDelete?.locationName} DOW location?
        </CustomConfirmationDialog>
      )}
    </>
  );
};

export default DOWMapping;
